export const MAP_ZOOM_CLOSE = 3;
export const MAP_ZOOM_MED = 2;
export const MAP_ZOOM_FAR = 1;
